import React from "react";
import dotProp from 'dot-prop-immutable';

/* Utilities */
import { trans } from '~/utilities';

export default function ProductSearchModelFilter({ filters, updateFilters, colClassName = 'col-12' }) {
    const brandFilterIndex = filters?.indexOf(filters?.find(filter => filter.key === 'brand'));
    const brandFilter = filters[brandFilterIndex]?.filters[0];
    const brand = brandFilter?.choices?.find(choice => choice.active);
    const modelFilterIndex = brandFilter?.choices?.indexOf(brand);
    const modelFilter = brandFilter?.choices[modelFilterIndex]?.filters[0];

    const updateChoice = (key) => {
        updateFilters(dotProp.set(filters, `${brandFilterIndex}.filters.0.choices.${modelFilterIndex}.filters.0.choices`, choices => choices.map(choice => ({ ...choice, active: choice.key === key }))));
    }

    return (
        <>
            <input type="hidden" name={`model[${brand?.key || ''}][]`} value={modelFilter?.choices?.find(choice => choice.active)?.key} />
            <div className={colClassName}>
                <label className="form-label" htmlFor="vehicle_search_model">
                    {trans('app.content_block.vehicle_search.filter.model.label')}
                </label>
                <select id="vehicle_search_model" className="custom-select" value={modelFilter?.choices?.find(choice => choice.active)?.key} onChange={(e) => updateChoice(e.target.value)}>
                    <option value="">{trans(`app.content_block.vehicle_search.filter.model.default_value`)}</option>
                    {modelFilter?.choices?.map(choice => (
                        <option key={choice.key} value={choice.key}>{choice.name}</option>
                    ))}
                </select>
            </div>
        </>
    );
}
